define('routers/accounts',[
	"require",
	"subroute",
	"views/accounts/linknewcard/linknewcard",
], function (require, subroute, LinkNewCardView) {
    "use strict";

    return Backbone.SubRoute.extend({
        initialize: function(options){
            options = options || {};
        },
        routes: {
            /* matches http://payforward.com/wallet */
            ""							: "showAccounts",
            "cardsuccess"				: "showCardSuccess",
            "linkcard(/:MGGD)(/:MGID)"  : "showLinkNewCard"
        },
        before: function(route, params){
            if(route){
                
                if(pf.session.get("auth") && pf.session.inApp){

                    switch (route) {
                        case "wallet":
                            pf.navigate("finregister");
                            break;
                    };

                }
                
            }
        },
        after: function(route, params){
            if (route) {}
        },
        showCardSuccess: function(){
            pf.require("views/user/register/financial/success", null, null, true, function () {
                require(["views/user/register/financial/success"], function (SuccessView) {
                    pf.show(new SuccessView({ elementName: "#mainRegion" }));
                });
            });
        },
        showLinkNewCard: function(MGGD,MGID){
            pf.show(new LinkNewCardView({
                elementName: "#mainRegion",
                MGGD: MGGD,
                MGID: MGID
            }));
        }

    });
});

